import type { AddressValidationResponse } from '../../shared';

export type EnteredAddressSnapshot = {
  address1: string;
  address2: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
};

type AddressBlockProps = {
  line1?: string | null;
  line2?: string | null;
  cityStateZip?: string | null;
  country?: string | null;
};

export function AddressBlock({ line1, line2, cityStateZip, country }: AddressBlockProps) {
  return (
    <div className="space-y-1 text-sm font-medium">
      {line1 && <p>{line1}</p>}
      {line2 && <p>{line2}</p>}
      {cityStateZip && <p>{cityStateZip}</p>}
      {country && <p>{country}</p>}
    </div>
  );
}

export function RecommendedAddressBlock({ result }: { result: AddressValidationResponse }) {
  const std = result.standardized_address;
  if (std) {
    return (
      <AddressBlock
        line1={std.first_address_line}
        line2={std.second_address_line}
        cityStateZip={std.city_state_zip}
        country="United States of America"
      />
    );
  }

  if (result.formatted_address) {
    return (
      <div className="space-y-1 text-sm font-medium">
        <p>{result.formatted_address}</p>
      </div>
    );
  }

  return null;
}
